const contacts = () => import('@/views/contacts/index.vue');
// const dataList = () => import('@/views/dataList.vue');
// const contactUs = () => import('@/views/contactus/index.vue');
// // const clinicalInfo = () => import('@/views/clinicalinfo/index.vue');
// // const clinicalDetail = () => import('@/views/clinicalinfo/detail.vue');
// const message = () => import('@/views/admin/message.vue');
// const usermanage = () => import('@/views/admin/usermanage.vue');
// const userinformation = () => import('@/views/admin/userinformation.vue');
// const recommen = () => import('@/views/admin/recommen.vue');
export const routerGroup = [
  {
    path: '/contacts',
    component: contacts,
    name: 'contacts',
    meta: {
      title: 'contacts',
    },
  },
  // {
  //   path: '/dataList',
  //   component: dataList,
  //   name: 'dataList',
  //   meta: {
  //     title: 'dataList',
  //   },
  // },
  // {
  //   path: '/contactus',
  //   component: contactUs,
  //   name: 'contactus',
  //   meta: {
  //     title: 'contactus',
  //   },
  // },
  // {
  //   path: '/clinicalinfo',
  //   component: clinicalInfo,
  //   name: 'clinicalinfo',
  //   meta: {
  //     title: 'clinicalinfo',
  //   },
  // },
  // {
  //   path: '/clinicaldetail',
  //   component: clinicalDetail,
  //   name: 'clinicaldetail',
  //   meta: {
  //     title: 'clinicaldetail',
  //   },
  // },
  // {
  //   path: '/message',
  //   component: message,
  //   name: 'message',
  //   meta: {
  //     title: 'message',
  //   },
  // },
  // {
  //   path: '/usermanage',
  //   component: usermanage,
  //   name: 'usermanage',
  //   meta: {
  //     title: 'User Management',
  //   },
  // },
  // {
  //   path: '/userinformation',
  //   component: userinformation,
  //   name: 'userinformation',
  //   meta: {
  //     title: 'User Information',
  //   },
  // },
  // {
  //   path: '/recommen',
  //   component: recommen,
  //   name: 'recommen',
  //   meta: {
  //     title: 'Recommendation',
  //   },
  // }
];
